import React from 'react';
import PropTypes from 'prop-types';

const variantClasses = {
  primary:
    'bg-blue-600 text-white border-blue-600 hover:bg-blue-700 hover:border-blue-700 active:bg-blue-800',
  secondary:
    'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400 active:bg-gray-100',
  ghost:
    'bg-transparent text-gray-700 border-transparent hover:bg-gray-100 active:bg-gray-200',
  danger:
    'bg-red-600 text-white border-red-600 hover:bg-red-700 hover:border-red-700 active:bg-red-800',
};

const sizeClasses = {
  sm: 'text-sm px-3 py-1.5 h-8',
  md: 'text-base px-4 py-2 h-10',
  lg: 'text-base px-6 py-3 h-12',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  fullWidth = false,
  disabled = false,
  className = '',
  href,
  ...props
}) => {
  const baseClasses = `
    inline-flex items-center justify-center gap-2 rounded-lg border font-medium
    transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
    ${variantClasses[variant]}
    ${sizeClasses[size]}
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;

  // Render as link if href is provided
  if (href && !disabled && !loading) {
    return (
      <a
        href={href}
        className={baseClasses}
        {...props}
      >
        {children}
      </a>
    );
  }

  // Render as button
  return (
    <button
      type="button"
      disabled={disabled || loading}
      className={baseClasses}
      {...props}
    >
      {loading && (
        <svg
          className="animate-spin h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'ghost', 'danger']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
};

export default Button;


